export default __webpack_public_path__ + "static/media/mnstr.781f9347.svg";